<web-design-system-modal [headline]="'savings-plan.served-by-modal.headline' | transloco" (dismiss)="modal.close('cancel')">
  <p>{{ 'savings-plan.served-by-modal.' + type + '.text' | transloco }}</p>
  <div class="d-flex justify-content-end mt-4">
    <web-design-system-button class="mr-2" type="secondary" size="small" (click)="modal.close('cancel')">
      {{ 'savings-plan.served-by-modal.' + type + '.cancel' | transloco }}
    </web-design-system-button>
    <web-design-system-button type="primary" size="small" (click)="modal.close('confirm')">
      {{ 'savings-plan.served-by-modal.' + type + '.submit' | transloco }}
    </web-design-system-button>
  </div>
</web-design-system-modal>
